<div class="schedule-event">
  <div class="schedule-event__circle" [style.backgroundColor]="_itemServiceColor"></div>
  <span class="schedule-event__label">{{ _label }}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/schedule-event-cell/schedule-event-cell.component.html